import React from "react";
import { Spinner } from "react-bootstrap";
import { ILoaderProps } from "./ILoaderProps";

export default function Loader(props: ILoaderProps) {
  return (
    <Spinner animation="border" variant="primary" size={props.size} style={props.style}/>
  );
}
